import React, { useState } from 'react';
import moment, { ISO_8601, now } from 'moment';
import { Icon } from 'components/ui';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { getStatusText } from '../../helpers';
import AttendancePopover from './AttendancePopover';

const isPast = date => moment(date, ISO_8601).isBefore(now());

const AttendanceStatus = ({
  attendee,
  event,
  hasAssignedContentAndFlag,
  showAttendanceDropdown,
  updateAttendance,
  isMultiSession,
}) => {
  const session = attendee.sessions[0];
  const { attendanceStatus } = session;
  const [popoverOpen, setPopoverOpen] = useState(false);

  const removeAttendance = () => {
    const url = routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
      session.id,
      session.attendanceId,
    );
    request.delete(url).then(({ success }) => {
      if (success) updateAttendance();
    });
  };

  const changeAttendanceStatus = (newStatus, assignContent = false) => {
    request
      .putJSON(
        routes.IN_PERSON_TRAINING.RSVP_SINGLE_GUESTS(event.id, session.id),
        {
          userId: attendee.id,
          attendanceStatus: newStatus,
        },
      )
      .then(({ data }) => {
        if (data?.sessions.length) {
          updateAttendance(data.sessions[0]);
          setPopoverOpen(false);
        }
      })
      .then(() => {
        if (newStatus === 'did_attend' && !!assignContent) {
          request.postJSON(
            routes.IN_PERSON_TRAINING.ASSIGN_CONTENT(event.id, session.id),
            { assigneeIds: [attendee.id] },
          );
        }
      });
  };

  const getStatusIcon = status => {
    switch (status) {
      case 'attended':
      case 'did_attend':
        return <Icon className="c-green mr-8" name="check" />;
      case 'did_not_attend':
        return <Icon className="c-red mr-8" name="close" />;
      case 'unconfirmed':
      default:
        return !isPast(session.startTime) ? null : (
          <span
            className="mr-8 h-c-night"
            data-toggle="tooltip"
            title={t('in_person_training.attendance.phrase.unconfirmed')}
            data-placement="top"
          >
            <Icon name="question" />
          </span>
        );
    }
  };

  return (
    <>
      <div>
        {getStatusIcon(attendanceStatus)}
        {getStatusText(
          attendanceStatus,
          false,
          isPast(session.startTime),
          true,
        )}
      </div>
      {showAttendanceDropdown &&
        !event.isArchived &&
        isPast(session.startTime) && (
          <div className="pos-r">
            <button
              type="button"
              onClick={() => setPopoverOpen(!popoverOpen)}
              className="u-resetBtn AttendanceRowActions"
            >
              <Icon name="chevron-down" />
            </button>
            {popoverOpen && (
              <AttendancePopover
                changeAttendanceStatus={changeAttendanceStatus}
                hasAssignedContentAndFlag={hasAssignedContentAndFlag}
                hide={() => setPopoverOpen(!popoverOpen)}
                isMultiSession={isMultiSession}
                removeAttendance={removeAttendance}
                status={attendanceStatus}
              />
            )}
          </div>
        )}
    </>
  );
};

export default AttendanceStatus;
